import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NamedEntityWithColor } from '../types/entities/NamedEntityWithColor';
import { SelectField } from '../components/Table/fields/SelectField';
import { color } from './color';

const makeEnumItemWithColor = (
  name: string,
  url: string,
  pluralName?: string
): SchemaWithClient<NamedEntityWithColor> => {
  return {
    name,
    pluralName: pluralName || `${name}s`,
    columns: {
      name: {
        name: 'Name',
        required: true,
        fieldRenderer: TextField,
        fieldType: 'text',
      },
      color: {
        name: 'Color',
        required: true,
        fieldRenderer: SelectField.tableAdapter(color),
        switchboard: true,
        url: color.client.getAllPath,
        tempSchema: color,
      },
      id: {
        name: 'ID',
        required: true,
        fieldRenderer: NumberField,
        fieldType: 'number',
        readOnly: true,
      },
    },
    client: new Client('/enums' + url),
  };
};

export const enumItemsWithColor = {
  salesPartner: makeEnumItemWithColor('Sales Partner', '/sales-partners'),
  activityCategory: makeEnumItemWithColor(
    'Activity Category',
    '/activity-categories'
  ),
  bookedBy: makeEnumItemWithColor('Booked By', '/booked-bies'),
};
